export type WorkLink = {
  title: string;
  url: string;
};
export const WorkLinksOptions: WorkLink[] = [
  { title: 'SSRS', url: 'http://ssrs.homesusa.com/Reports/report' },
  { title: 'Jira', url: 'https://homesusa.atlassian.net/jira' },
  { title: 'Confluence', url: 'https://www.atlassian.com/software/confluence' },
  {
    title: 'Knowledge Base',
    url: 'https://homesusa.atlassian.net/wiki/apps/c45f91b1-c6f8-4e93-b63f-c432728e404d/6fdb200b-014c-458e-b3f0-49e268fa3f93/chatgpt-confluence'
  },
  { title: 'Monday', url: 'https://freddfazms-team.monday.com' },
  {
    title: 'Sharepoint',
    url: 'https://homesusainc.sharepoint.com/sites/HomesUSA.comInc/SitePages/Home.aspx'
  },
  { title: 'Planner', url: 'https://tasks.office.com/' },
  { title: 'Azure Xml', url: 'https://go.microsoft.com/fwlink/?linkid=2216182' },
  {
    title: 'Performance Report',
    url: 'https://ssrs.homesusa.com/Reports/report/SpecDeck/All%20Residential%20Listing%20Request%20Report%20(SpecDeck)'
  },
  {
    title: 'Daily Agenda',
    url: 'https://homesusainc-my.sharepoint.com/:w:/g/personal/freddy_homesusa_com/EcgjDeVt-ERNut0faNyiM1kBWPaW05YGlA-M8mSTx94jkg?e=IDcLuE'
  },
  {
    title: 'Features Plan',
    url: 'https://homesusainc.sharepoint.com/:x:/s/HomesUSA.comInc/ERLgFzjmAgpJljyPEVIQMU8BWA3MZT73Tu7KDvR7FB9xyQ?e=FrtNsG'
  }
];
